import '../../core/components/app-root/AppRoot.css';
import './Page.css';
export var page = '_1j29czt0-3-12-1';